import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { AltraParte } from 'src/app/common/models/altraparte';
import { Parte } from 'src/app/common/models/parte';
import { OperationsService } from 'src/app/core/services/operations.service';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { SearchAnagraficheResponse } from 'src/app/common/models/dto/search-anagrafiche-response';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { TipoPersona } from 'src/app/common/models/tipologiche/tipo-persona';
import { SearchTextComponent } from 'src/app/common/components/input-component/searchText/search-text.component';
import { filterElaborationEntity, filterElaborationEntityClean, getMockEntity, isNumeric } from '../../utils/wizard-utils';
import { ElaborationEntityConstants } from '../../constants/elaboration-entity-constants';
import { extractParteEntityFromSearch, isDuplicate, isParteAssociable, parteFromEntity, setTempId } from '../../utils/parti-utils';
import { isAltraparteAssociated } from '../../utils/altraparte-utils';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { Subject, combineLatest, concat } from 'rxjs';
import { distinctUntilChanged, filter, skipWhile, take, takeUntil, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-step-soggetti-terzi',
  templateUrl: './step-soggetti-terzi.component.html',
  styleUrls: ['./step-soggetti-terzi.component.css']
})
export class StepSoggettiTerziComponent implements OnInit, OnDestroy {

  @ViewChild('searchElement') searchElement: SearchTextComponent;
  requestSearchUrl = ServicePathsSettings.URL_SEARCH_PARTE;
  foundElements: { isAssociable: boolean, isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte }[] = [];
  suggeritiFound: { isAssociable: boolean, isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte, categoria?: string, tipoSoggetto?: string }[] = [];
  altreParti: AltraParte[] = [];
  activeTab = 0;
  parte: Parte = null;
  entitiesFiltered: ElaborationDocumentFilterEntity[] = [];
  action: string;
  tipoPersonaOptions: TipoPersona[] = [];
  hasSearched: boolean = false;
  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>();
  count = 0;
  componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(private operations: OperationsService,
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private tipologicheService: CreazionePraticaTipologicheService,
    private router: Router) { }

  ngOnInit() {
    this.count = 0;
    this.suggeritiFound = []
    this.foundElements = []
    this.entitiesFiltered = []
    this.creazionePraticaStoreService.soggettoTerzo$.subscribe(altreParti => {
      if (altreParti && altreParti.length > 0) {
        this.altreParti = altreParti;
      } else {
        this.altreParti = []
      }
      this.checkParteisAltraparte();
    })


    const soggettiTerziSuggestedStored$ = this.creazionePraticaStoreService.suggestedSoggettiTerzi$.pipe(
      take(1),
      filter(suggested => suggested.length > 0),
      tap(suggested => this.suggeritiFound = suggested),
    );

    const entitiesAndTipiPersona$ = combineLatest(
      this.creazionePraticaStoreService.entities$.pipe(
        distinctUntilChanged(),
        filter(entities => entities.length > 0),
        tap(entities => {
          this.entitiesFiltered = filterElaborationEntityClean(entities, [ElaborationEntityConstants.LEGAL_PRINCIPAL_ACTOR,
          ElaborationEntityConstants.LEGAL_DEFENDANT,
          ElaborationEntityConstants.OTHER_COUNTER_PARTS]);
        })

      ),
      this.tipologicheService.getTipiPersona().pipe(
        distinctUntilChanged(),
        tap(tipoPersonaOptions => this.tipoPersonaOptions = tipoPersonaOptions)
      )
    ).pipe(take(1));


    concat(soggettiTerziSuggestedStored$, entitiesAndTipiPersona$).pipe(
      takeUntil(this.componentDestroyed$),
      skipWhile(() => this.suggeritiFound.length > 0),
    ).subscribe(() => this.getSuggeriti());
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

  private getSuggeriti() {
    if (this.entitiesFiltered && this.entitiesFiltered.length > 0 && this.tipoPersonaOptions && this.tipoPersonaOptions.length > 0) {
      if (this.router.url.endsWith('consultazione')) {//logica per il wizard di consultazione
        let outputArray: ElaborationDocumentFilterEntity[] = [];
        this.entitiesFiltered.forEach(obj => {
          let cleanedValore = obj.valore.replace(/nome:|cognome:|ragioneSociale:/g, "").trim();
          let formattedObj = Object.assign({}, obj);
          formattedObj.valore = cleanedValore;
          outputArray.push(formattedObj);
        });
        outputArray.forEach(element => this.operations.searchAnagrafiche(ServicePathsSettings.URL_SEARCH_PARTI_TUTTE, { searchText: element.valore.substring(0, element.valore.indexOf(" categoria") != -1 ? element.valore.indexOf(" categoria") : element.valore.length - 1), fromResult: 0 }).subscribe(response => {
          let filteredResponse = response
          let anagraficheResponse: any[] = [];
          if (response.anagrafiche && response.anagrafiche !== null) {
            response.anagrafiche.forEach(response => {
              if (response.nome && element.valore.toUpperCase().includes(response.nome.toUpperCase()) &&
                response.cognome && element.valore.toUpperCase().includes(response.cognome.toUpperCase())) {
                if (element.uri.includes('_') && response.codiceFiscale) {
                  if (element.uri.toUpperCase().includes(response.codiceFiscale.toUpperCase())) {
                    if (!isDuplicate(response, anagraficheResponse))
                      anagraficheResponse.push(response);
                  }
                } else {
                  if (!isDuplicate(response, anagraficheResponse))
                    anagraficheResponse.push(response);
                }
              } else if (response.ragioneSociale && element.valore.toUpperCase().includes(response.ragioneSociale.toUpperCase())) {
                if (element.uri.includes('_') && response.partitaIva) {
                  if (element.uri.toUpperCase().includes(response.partitaIva.toUpperCase())) {
                    if (!isDuplicate(response, anagraficheResponse))
                      anagraficheResponse.push(response);
                  }
                } else {
                  if (!isDuplicate(response, anagraficheResponse))
                    anagraficheResponse.push(response);
                }
              }
            })

          }
          filteredResponse.anagrafiche = anagraficheResponse;
          this.suggerimentiDaRicerca(filteredResponse, element);
          this.creazionePraticaStoreService.setSuggestedSoggettiTerzi(this.suggeritiFound);
          console.log(this.suggeritiFound);
        }));

      } else {
        this.entitiesFiltered.forEach(element => {
          this.operations.searchAnagrafiche(ServicePathsSettings.URL_SEARCH_PARTI_TUTTE, { searchText: element.valore, fromResult: 0 }).subscribe(response => {
            this.suggerimentiDaRicerca(response, null);
            this.creazionePraticaStoreService.setSuggestedSoggettiTerzi(this.suggeritiFound);
          });
        });
      }
    }
  }

  public suggerimentiDaRicerca(response: SearchAnagraficheResponse, entity: any) {
    let categoria;
    let tipoSoggetto;
    this.count = this.count + 1;
    let listaFiltrata: any[] = [];
    if (response && response.anagrafiche) {
      listaFiltrata = response.anagrafiche;
      for (let element of listaFiltrata) {
        if (!element.rimosso) {
          if (entity) {
            if (entity.valore.includes('categoria: ') && entity.valore.includes('tipoSoggetto: ')) {
              //recupera dal valore categoria e tipo
              categoria = entity.valore.substring(entity.valore.indexOf('categoria: ') + 'categoria: '.length, (entity.valore.indexOf(' tipoSoggetto: ')));
              tipoSoggetto = entity.valore.substring(entity.valore.indexOf('tipoSoggetto: ') + 'tipoSoggetto: '.length);
            } else {
              categoria = null;
              tipoSoggetto = null;
            }

          }
          let altraparte = new AltraParte();
          altraparte.parte = element;
          let isAssociable = isParteAssociable(element);
          this.suggeritiFound.push({ isAssociable: isAssociable, isAssociated: false, hasDetailsAnagrafica: false, option: altraparte, categoria: categoria !== '-' ? categoria : null, tipoSoggetto: tipoSoggetto != '-' ? tipoSoggetto : null });
        }
      }
    }

    if (this.count === this.entitiesFiltered.length) {
      let parti: Parte[] = [];
      this.suggeritiFound.forEach(element => {
        parti.push(element.option.parte);
      });
      this.entitiesFiltered.forEach(entity => {
        const parteExtracted = extractParteEntityFromSearch(this.tipoPersonaOptions, entity, parti);
        if (parteExtracted) {
          if (entity) {
            if (entity.valore.includes('categoria: ') && entity.valore.includes('tipoSoggetto: ')) {
              //recupera dal valore categoria e tipo
              categoria = entity.valore.substring(entity.valore.indexOf('categoria: ') + 'categoria: '.length, (entity.valore.indexOf(' tipoSoggetto: ')));
              tipoSoggetto = entity.valore.substring(entity.valore.indexOf('tipoSoggetto: ') + 'tipoSoggetto: '.length);
            } else {
              categoria = null;
              tipoSoggetto = null;
            }

          }
          let altraparte = new AltraParte();
          altraparte.parte = parteExtracted;
          let isAssociable = isParteAssociable(parteExtracted);
          this.suggeritiFound.push({ isAssociable: isAssociable, isAssociated: false, hasDetailsAnagrafica: false, option: altraparte, tipoSoggetto: tipoSoggetto != '-' ? tipoSoggetto : null });
        }
      });
    }
    this.checkParteisAltraparte();
  }

  retrieveNewSoggettoTerzo(soggetto: AltraParte) {
    soggetto.parte = setTempId(soggetto.parte);
    this.altreParti.push(soggetto);
    this.creazionePraticaStoreService.setSoggettiTerzi(this.altreParti);
    this.creazionePraticaStoreService.save();
    this.parte = null;
    this.activeTab = 0;
  }

  public retrieveSearch(response: SearchAnagraficheResponse) {
    this.hasSearched = true;
    this.foundElements = [];
    let listaFiltrata: any[] = [];
    if (response && response.anagrafiche) {
      listaFiltrata = response.anagrafiche;
      for (let element of listaFiltrata) {
        let altraparte = new AltraParte();
        altraparte.parte = element;
        let isAssociable = isParteAssociable(element);
        this.foundElements.push({ isAssociable: isAssociable, isAssociated: false, hasDetailsAnagrafica: false, option: altraparte });
      }
    }
  }

  reset(): void {
    this.count = 0;
    this.creazionePraticaStoreService.setSoggettiTerzi([]);
    this.creazionePraticaStoreService.save();
    this.altreParti = [];
    // this.suggeritiFound = []
    // this.foundElements = []
    // this.getSuggeriti();
  }

  salva(): void {
    this.creazionePraticaStoreService.setSoggettiTerzi(this.altreParti);
    this.creazionePraticaStoreService.save();
    this.changeStep.emit();
  }

  private checkParteisAltraparte() {
    this.suggeritiFound.forEach(element => {
      isAltraparteAssociated(element, this.altreParti)
    });
  }

}
